import React, { useState } from "react";
import { Modal, Button, message } from "antd";

import { salvarAtualizacaoCadastral } from "../../services/http/usuariosService";
import "./styles.scss";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// RD 96214: atualização cadastral obrigatória do participante. Sem X, Esc,
// clique fora ou botão Sair: só some depois de salvar.
const ModalAtualizacaoCadastral = ({ dados, onConcluido }) => {
  const [concessionario, setConcessionario] = useState(null);
  const [email, setEmail] = useState(dados.email || "");
  const [concessionariaId, setConcessionariaId] = useState(
    dados.concessionariaId || ""
  );
  const [erros, setErros] = useState({});
  const [salvando, setSalvando] = useState(false);

  const salvar = async () => {
    const novosErros = {};
    if (!EMAIL_REGEX.test(email.trim())) novosErros.email = "Informe um e-mail válido";
    if (concessionario && !concessionariaId)
      novosErros.concessionariaId = "Selecione a concessionária";
    setErros(novosErros);
    if (Object.keys(novosErros).length) return;

    setSalvando(true);
    const resposta = await salvarAtualizacaoCadastral({
      email: email.trim(),
      concessionario,
      concessionariaId: concessionario ? concessionariaId : null,
    });
    setSalvando(false);

    if (resposta.fail) {
      message.error(
        resposta.errors?.message ||
          "Não foi possível salvar a atualização cadastral"
      );
      return;
    }

    message.success("Cadastro atualizado com sucesso");
    onConcluido();
  };

  return (
    <Modal
      visible
      className="modal-atualizacao-cadastral"
      title="Atualização cadastral"
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
    >
      {concessionario === null ? (
        <>
          <p>
            Para continuar acessando o Mídia Center, é necessário atualizar o
            seu cadastro.
          </p>
          <p>
            <strong>
              Você é concessionário ou representa alguma concessionária?
            </strong>
          </p>
          <div className="d-flex justify-content-end" style={{ gap: 8 }}>
            <Button onClick={() => setConcessionario(false)}>Não</Button>
            <Button type="primary" onClick={() => setConcessionario(true)}>
              Sim
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="form-group mb-3">
            <label>
              E-mail <span className="required">*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`form-control ${erros.email ? "is-invalid" : ""}`}
            />
            {erros.email && (
              <div className="invalid-feedback">{erros.email}</div>
            )}
          </div>

          {concessionario ? (
            <div className="form-group mb-3">
              <label>
                Concessionária <span className="required">*</span>
              </label>
              <select
                value={concessionariaId}
                onChange={(e) => setConcessionariaId(e.target.value)}
                className={`form-control ${
                  erros.concessionariaId ? "is-invalid" : ""
                }`}
              >
                <option value="">Selecione</option>
                {(dados.concessionarias || []).map((concessionaria) => (
                  <option key={concessionaria.id} value={concessionaria.id}>
                    {concessionaria.codigoDealer} - {concessionaria.nomeFantasia}
                  </option>
                ))}
              </select>
              {erros.concessionariaId && (
                <div className="invalid-feedback">
                  {erros.concessionariaId}
                </div>
              )}
            </div>
          ) : (
            <p>
              Seu cadastro será vinculado ao Dealer <strong>Outros</strong>.
            </p>
          )}

          <div className="d-flex justify-content-end" style={{ gap: 8 }}>
            <Button
              disabled={salvando}
              onClick={() => {
                setErros({});
                setConcessionario(null);
              }}
            >
              Voltar
            </Button>
            <Button type="primary" loading={salvando} onClick={salvar}>
              Salvar
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ModalAtualizacaoCadastral;
